// src/Contexts/AuthContext.tsx

import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserInfo, fetchUserAccess } from "../Services/Slices/authSlice";
import type { AppDispatch, RootState } from "../Services/Store";

interface AuthContextType {
  isAuthenticated: boolean;
  setAuthenticated: (auth: boolean) => void;
  authLoading: boolean;
}

const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  setAuthenticated: () => {},
  authLoading: false,
});

export const AuthProvider = ({ children }: { children: ReactNode }) => {

  const getToken = () =>
    !!localStorage.getItem("token") || !!sessionStorage.getItem("token");

  const [isAuthenticated, setAuthenticated] = useState<boolean>(getToken());
  const [authLoading, setAuthLoading] = useState<boolean>(false);


  const dispatch = useDispatch<AppDispatch>();

  
  const reduxLoading = useSelector((state: RootState) => state.auth.loading);

  
useEffect(() => {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token");

  if (token) {
    setAuthenticated(true);
    setAuthLoading(true);

    dispatch(fetchUserInfo());
    dispatch(fetchUserAccess());
    // Wait a bit and log Redux state
    setTimeout(() => {
      // This will only work if you import your store directly!
      // import store from "../Services/Store";
      // console.log("Redux state after fetchUserInfo", store.getState().auth);
      // OR log from useSelector:
      // const user = useSelector((state: RootState) => state.auth.user);
      // console.log("User from Redux after reload", user);
    }, 1500);
  } else {
    setAuthenticated(false);
  }
}, [dispatch]);



  
  useEffect(() => {
    if (isAuthenticated && reduxLoading === false) {
      setAuthLoading(false);
    } else if (!isAuthenticated) {
      setAuthLoading(false);
    }
  }, [isAuthenticated, reduxLoading]);

  
  useEffect(() => {
    const syncAuth = () => {
      const tokenStillThere = getToken();
      setAuthenticated(tokenStillThere);
    };
    window.addEventListener("storage", syncAuth);
    window.addEventListener("focus", syncAuth);
    return () => {
      window.removeEventListener("storage", syncAuth);
      window.removeEventListener("focus", syncAuth);
    };
  }, []);

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, setAuthenticated, authLoading }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
